<p-blockUI [blocked]="saving === true" />

@if (!this._deviceService.isMobile()) {
  <p-panel [showHeader]="false" styleClass="hidden-panel">
    <div class="no-padding display-flex table-container">
      <div class="contact-list-table">
        <div class="contact-list-header">
          <div>
            <app-progress-spinner [enabled]="saving" />
          </div>
          <div class="row">
            <div class="row-item">
              <span class="label">{{ 'CONTACT.LABEL.NAME' | translate }}:</span>
              <div class="input">
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="name"
                  [disabled]="!this.canEdit"
                  (change)="saveContactList()"
                />
              </div>
            </div>
            <div class="row-item">
              <span class="label contact-list-input"
                >{{ 'CONTACT.LABEL.MEMBER_CODES' | translate }}:
              </span>
              <div>{{ this.codesToDisplay }}</div>
            </div>
            <div class="margin">
              <span class="label small-margin-right"
                >{{ 'COMMON.LABEL.BUSINESS_UNITS' | translate }}:<span
                  class="required"
                  >*</span
                ></span
              >
              <span>
                <p-multiSelect
                  [options]="availableBusinessUnits"
                  [(ngModel)]="selectedBusinessUnits"
                  [style]="{ width: 'inherit' }"
                  (onChange)="saveContactList()"
                  [disabled]="!this.canEdit"
                />
              </span>
            </div>
            <div class="arl-section">
              <label class="label"
                >{{
                  'CONTACT.LABEL.ADDITIONAL_RESOURCE_LIST_TYPE' | translate
                }}:</label
              >
              <p-select
                [options]="additionalResourceListTypes"
                [(ngModel)]="additionalResourceListTypeId"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                filterBy="name"
                appendTo="body"
                [virtualScroll]="true"
                [virtualScrollItemSize]="34"
                class="dropdown"
                placeholder="{{
                  'CONTACT.LABEL.ADDITIONAL_RESOURCE_LIST_PLACEHOLDER'
                    | translate
                }}"
                [disabled]="!canEdit"
                (onChange)="handleARLChanges($event)"
                [showClear]="true"
              />
            </div>
            <div class="manage-button">
              <button
                pButton
                label="{{ 'CONTACT.LABEL.MANAGE_MEMBER_CODES' | translate }}"
                icon="fa fa-fw fa-tags"
                [disabled]="
                  !(this.canAddMemberCodes || this.canRemoveMemberCodes)
                "
                (click)="manageMemberCodes()"
              ></button>
            </div>
            @if (
              this.canEdit ||
              this.canEditDirectReports ||
              this.canEditOwn ||
              this.isAnUpdater
            ) {
              <div class="button">
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
                  icon="fa fa-fw fa-plus"
                  (click)="addContact()"
                  [disabled]="saving"
                ></button>
              </div>
              <div>
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.DELETE' | translate }}"
                  icon="fa fa-fw fa-trash"
                  (click)="deleteContact()"
                  [disabled]="!selectedEmployees || saving"
                ></button>
              </div>
            }
          </div>
        </div>

        @if (contactList?.members?.length! > 0 && !addingContact) {
          <div class="no-padding list-card">
            <p-orderList
              [value]="orderableMembers"
              [styleClass]="orderListStyle"
              (onReorder)="contactListReorder()"
              [(selection)]="selectedEmployees"
              [dragdrop]="dragDropEnabled"
              controlsPosition="left"
              (onSelectionChange)="onSelectionChange($event)"
              scrollHeight="55vh"
              #olist
            >
              <ng-template let-m pTemplate="item" let-index="index">
                <app-contact-list-card
                  [member]="m"
                  [index]="index"
                  (openProfileEvent)="openEmployeeProfile($event)"
                  class="cl-card"
                />
              </ng-template>
            </p-orderList>
          </div>
        }
      </div>
    </div>
  </p-panel>
}
@if (this._deviceService.isMobile()) {
  <div>
    <div class="no-padding">
      <div class="no-padding">
        <span class="label no-padding"
          >{{ 'CONTACT.LABEL.NAME' | translate }}:</span
        >
        <div class="no-padding">
          <input
            type="text"
            pInputText
            [(ngModel)]="name"
            (change)="saveContactList()"
          />
        </div>
      </div>
    </div>

    <div class="no-padding" id="mobile-member-codes">
      <div class="row-item member-codes">
        <span class="label contact-list-input"
          >{{ 'CONTACT.LABEL.MEMBER_CODES' | translate }}:
        </span>
        <div>{{ this.codesToDisplay }}</div>
      </div>
    </div>
  </div>
}
<br />

@if (this._deviceService.isMobile()) {
  <p-panel
    [showHeader]="true"
    [toggleable]="true"
    toggler="header"
    [(collapsed)]="empCollapsed"
    header="Employees"
    styleClass="hidden-panel"
  >
    <div class="no-padding">
      <p-scrollPanel styleClass="contact-list-scroll-panel">
        <div class="no-padding">
          <p-orderList
            [value]="orderableMembers"
            [styleClass]="orderListStyle"
            [listStyle]="{ height: 'calc(100vh - 400px)' }"
            (onReorder)="contactListReorder()"
            [(selection)]="selectedEmployees"
            [dragdrop]="dragDropEnabled"
            (onSelectionChange)="onSelectionChange($event)"
          >
            <ng-template let-m pTemplate="item" let-index="index">
              <app-contact-list-card
                [member]="m"
                [index]="index"
                (openProfileEvent)="openEmployeeProfile($event)"
              />
            </ng-template>
          </p-orderList>
        </div>
      </p-scrollPanel>
    </div>
  </p-panel>
}

<p-dialog
  header="Add Contacts To List"
  [(visible)]="displayDialog"
  showEffect="fade"
  [modal]="true"
  [transitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
  appendTo="body"
>
  <form [formGroup]="addContactToListForm">
    <div id="add-contact-create-form" class="add-contact-form">
      <div class="row">
        <span class="label">{{ 'CONTACT.LABEL.CONTACT' | translate }}:</span>
        <span class="input">
          <p-autoComplete
            [suggestions]="filteredContacts"
            (completeMethod)="contactSearch($event)"
            formControlName="contact"
            [dropdown]="true"
            optionLabel="label"
            optionValue="value"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            appendTo="body"
          />
        </span>
      </div>
      <div class="button">
        <button
          pButton
          label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
          icon="fa fa-fw fa-save"
          (click)="addContactToList()"
          [disabled]="!this.addContactToListForm.valid"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<app-member-codes-form
  [isVisible]="displayMemberCodesDialog"
  [contactList]="contactList!"
  formTitle="Manage Member Codes - {{ contactList!.name }}"
  (memberCodesHidden)="onMemberCodesHidden()"
  (memberCodesUpdated)="onMemberCodesUpdated($event)"
  #memberCodeForm
/>
